import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import connect from 'react-redux/es/connect/connect';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import { Formik } from 'formik';
import i18n from 'i18next';

import { BATCH_UPDATE_MODE, entityType, fieldKey } from '../../constants';
import { filterActions } from '../../behavior/filter';
import { dataViewActions } from '../../behavior/dataview';

import FiltersPanel from '../Filtering/FiltersPanel/FiltersPanel';
import OverviewTable from '../Filtering/OverviewTable/OverviewTable';
import BatchUpdateSelectedContainer from './BatchUpdateSelectedContainer';
import FilteringContextProvider from '../Filtering/FilteringContextProvider';
import BatchUpdateFieldListContainer from './BatchUpdateFieldListContainer';
import getBatchUpdateFormSchema from '../../formSchemas/ButchUpdateFormSchema';
import { inventoriesActions } from '../../behavior/inventories';
import { useTitleProvider } from '../TitleContextProvider';
import { Loading, AccordionWrapper } from 'react-lib/dist/components-es';
import { useTranslation } from 'react-i18next';

const BatchUpdateContainer = ({
  actions,
  entityTypeProps,
  allFilters,
  defaultFilteredList,
  processedNotificationBody,
  recipients,
  isContactOverrideMode
}) => {
  const { t } = useTranslation();
  const filterProps = allFilters[entityTypeProps] || {};
  const [titleState, dispatch] = useTitleProvider();
  const [selectedRows, setSelectedRows] = useState({});
  const [validateOnChange, setValidateOnChange] = useState(false);
  const [selectedRowsFromOverviewPage, setSelectedRowsFromOverviewPage] = useState(
    titleState.selectedRowsForBatchUpdate ? titleState.selectedRowsForBatchUpdate : {}
  );
  const filteringContextProviderRef = useRef(null);

  useEffect(() => {
    actions.getDefaultDataView(entityTypeProps);
    actions.initializeFiltering(entityTypeProps);
  }, []);

  useEffect(() => {
    dispatch(prevState => ({ ...prevState, pageTitle: t('page.batchUpdate.title') }));
  }, [i18n.language]);

  const [selectedInventories, setSelectedInventories] = useState([]);
  const [selectedInventoriesCounter, setSelectedInventoriesCounter] = useState(0);
  const [selectedFields, setSelectedFields] = useState([]);

  const mode = BATCH_UPDATE_MODE;

  const setSelectedRowsAndConvertToObj = selectedRows => {
    setSelectedRows(selectedRows);
    if (Object.keys(selectedRows).length === 0) {
      selectedInventories.splice(0, selectedInventories.length);
    } else {
      Object.keys(selectedRows).forEach(entry => {
        let inventoryObj = filterProps.filteredList.result.find(r => r.ID === entry);
        if (
          inventoryObj !== undefined &&
          !selectedInventories.map(i => i.ID).includes(inventoryObj.ID)
        ) {
          selectedInventories.push(inventoryObj);
        }
      });
    }
  };

  let handleSubmit = (values, action) => {
    let inventory = values;

    if (
      inventory.chemicalProduct &&
      inventory.chemicalProduct.selectedChemicalProduct &&
      inventory.chemicalProduct.selectedChemicalProduct.id
    ) {
      inventory.chemicalProduct.id = inventory.chemicalProduct.selectedChemicalProduct.id;
    }
    let chemicalProduct = null;
    let saveRequestDto = {
      inventory,
      chemicalProduct,
      processedNotificationBody,
      recipients,
      inventoriesIdsBatch: Object.keys(selectedRows).map(r => Number(r)),
      batchUpdatedFields: selectedFields.flatMap(field => field.key == fieldKey.GEN_IS_CHECK_VALID ? [fieldKey.GEN_CHECK_USER, fieldKey.GEN_CHECK_DATE] : field.key),
      lang: i18n.language,
      contactOverrideMode: isContactOverrideMode
    };

    actions.save(saveRequestDto, mode);
    action.setSubmitting(false);
  };

  return defaultFilteredList !== undefined &&
    filterProps.possibleFieldsList !== undefined &&
    filterProps.possibleFieldsList.length > 0 &&
    filterProps.visibleFieldsList.length > 0 &&
    filterProps.visibleColumnsList.length > 0 &&
    filterProps.visibleColumnsList.length > 0 &&
    JSON.stringify(defaultFilteredList.result.entityType) ===
      JSON.stringify(entityType.batchUpdate) ? (
    <Grid columns="equal" stackable>
      <Grid.Row stretched columns={4} style={{ margin: '10px 0 5px 0', padding: '10px 0  0' }}>
        <FilteringContextProvider
          ref={filteringContextProviderRef}
          visibleColumns={filterProps.visibleColumnsList}
          visibleFields={filterProps.visibleFieldsList}
          actions={actions}
          entityType={entityTypeProps}
          filterProps={filterProps}
          defaultFilteredList={defaultFilteredList}
          tableOptions={[]}
          selectedRows={{}}
        >
          <Grid.Column width={3} style={{ margin: '0 5px 0 5px', padding: '0 0 0 10px' }}>
            <AccordionWrapper
              titleClassName={'accordionHeaderCompact'}
              className="filterPanel"
              accordionTitle={'1. ' + t('filter.panel.title')}
              closable={false}
              render={() => <FiltersPanel numberOfGridColumns={1} showOptions={false} />}
            />
          </Grid.Column>
          <Grid.Column style={{ margin: '0 0 0 5px', padding: '0px' }}>
            <AccordionWrapper
              titleClassName={'accordionHeaderCompact'}
              className="filterPanel batchUpdateSearchResults"
              accordionTitle={'2. ' + t('inventory.batch.update.search.result')}
              closable={false}
              render={() => (
                <OverviewTable
                  renderColumnSelector={false}
                  renderSorting={false}
                  renderRecordsPerPage={false}
                />
              )}
            />
          </Grid.Column>
        </FilteringContextProvider>

        <BatchUpdateSelectedContainer
          allFilters={allFilters}
          filteredList={selectedInventories}
          setSelectedInventoriesParent={setSelectedInventories}
          selectedRowsFromOverviewPage={selectedRowsFromOverviewPage}
          renderSelection={true}
          entityTypeProps={entityType.batchUpdateSelected}
          setSelectedInventoriesCounter={setSelectedInventoriesCounter}
          parentFilterContextRef={filteringContextProviderRef}
          setSelectedRowsAndConvertToObj={setSelectedRowsAndConvertToObj}
        />
      </Grid.Row>
      <Grid.Row stretched style={{ margin: '0px', padding: '0px' }}>
        <Grid.Column style={{ margin: '10px 5px 0 5px', padding: '0 10px 0 10px' }}>
          <Formik
            validationSchema={getBatchUpdateFormSchema(selectedFields)}
            validateOnChange={validateOnChange}
            onSubmit={handleSubmit}
            render={formikProps => (
              <BatchUpdateFieldListContainer
                formikProps={formikProps}
                setValidateOnChange={setValidateOnChange}
                selectedFields={selectedFields}
                setSelectedFields={setSelectedFields}
                numberOfSelectedInventories={selectedInventoriesCounter}
                mode={mode}
              />
            )}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  ) : (
    <Loading isLoading={true} />
  );
};

BatchUpdateContainer.propTypes = {
  actions: PropTypes.shape({
    initializeFiltering: PropTypes.func.isRequired,
    applyFilterAction: PropTypes.func.isRequired,
  }).isRequired,
  entityTypeProps: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  processedNotificationBody: state.changesNotificationModal.processedChangesNotification,
  recipients: state.changesNotificationModal.recipients,
  allFilters: state.filter,
  entityTypeProps: entityType.batchUpdate,
  ...state.dataView,
  ...state.defaultFilteredList,
  isContactOverrideMode: state.batchUpdate.isContactOverrideMode,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    initializeFiltering: entityType => dispatch(filterActions.initializeFiltering(entityType)),
    applyFilterAction: (entityType, filterState, filters) =>
      dispatch(filterActions.applyFilterV2(entityType, filterState, filters)),
    getDefaultDataView: entityType => {
      dispatch(dataViewActions.getDefaultDataView(entityType, null, null));
    },
    save: (saveDto, mode) => dispatch(inventoriesActions.saveInventory(saveDto, mode)),
  },
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(BatchUpdateContainer);
